import React, { useEffect, useState } from "react";

const InfoNote = ({ note }) => {
  const [show, setShow] = useState(false);
  // console.log('here')
  // useEffect(()=>{

  //   alert('k')
  // },[])
  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        marginLeft: "6px",
      }}
    >
      <span
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(!show)}
        style={{
          cursor: "pointer",
          color: "#007bff",
          fontWeight: "bold",
          border: "1px solid #007bff",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          lineHeight: "1",
          background: "white",
        }}
      >
        ?
      </span>

      {show && (
        <div
          style={{
            position: "absolute",
            top: "120%", // 👇 appears below the icon
            left: "50%",
            transform: "translateX(-50%)",
            width: "300px",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px",
            borderRadius: "6px",
            fontSize: "13px",
            zIndex: 9999, // 👆 ensures it appears above modal
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          }}
        >
          {note}
          <div
            style={{
              position: "absolute",
              top: "-6px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "0",
              height: "0",
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderBottom: "6px solid #333",
            }}
          ></div>
        </div>
      )}
    </span>
  );
};

export default InfoNote;
